module.exports = __webpack_public_path__ + "static/palm_logo-7c285474eedd2432c0f4b4401cd1c5e8.png";